

/// <reference path="BusinessLog.ts" />

// Generated class SeasonStartLog_ManagedObject

class SeasonStartLog_ManagedObject extends BusinessLog
{

    // Property: startDate
    set startDate(value:Date) {
        this.setValueForKey(value, 'startDate');
    }
    get startDate():Date {
        return this.valueForKey('startDate');
    }
    set startDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'startDate');
    }
    get startDatePrimitiveValue():Date {
        return this.primitiveValueForKey('startDate');
    }
    // Relationship: license
    set license(value:License) {
        this.setValueForKey(value, 'license');
    }
    get license():License {
        return this.valueForKey('license') as License;
    }
}
